const t = {
  getStatusColor: (o = "default") => ({
    error: {
      color: "var(--color-error-default)",
      border: "1px solid var(--color-error-default)",
      hover: {
        border: "1px solid var(--color-error-strong)"
      },
      focus: {
        border: "1px solid var(--color-error-default)",
        color: "green"
      }
    },
    success: {
      color: "var(--color-success-default)",
      border: "1px solid var(--color-success-default)",
      hover: {
        border: "1px solid var(--color-success-strong)"
      },
      focus: {
        border: "1px solid var(--color-success-default)"
      }
    },
    warning: {
      color: "var(--color-warning-default)",
      border: "1px solid var(--color-warning-default)",
      hover: {
        border: "1px solid var(--color-warning-strong)"
      },
      focus: {
        border: "1px solid var(--color-warning-default)"
      }
    },
    info: {
      color: "var(--color-info-default)",
      border: "1px solid var(--color-info-default)",
      hover: {
        border: "1px solid var(--color-info-strong)"
      },
      focus: {
        border: "1px solid var(--color-info-default)"
      }
    },
    default: {
      color: "var(--color-components-input-fg-default)",
      border: "1px solid var(--color-components-input-border-default)",
      hover: {
        border: "1px solid var(--color-components-input-border-hover-default)"
      },
      focus: {
        border: "1px solid var(--color-accent-primary-default)",
        color: "var(--color-accent-primary-default)"
      }
    }
  })[o],
  sizes: {
    sm: {
      fontSize: "1.4rem"
    },
    md: {
      fontSize: "1.4rem"
    },
    lg: {
      fontSize: "1.6rem"
    }
  },
  checkUrlInput(o) {
    try {
      !o.startsWith("http://") && !o.startsWith("https://") && (o = "https://" + o);
      const r = new URL(o);
      return /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(r.hostname);
    } catch (r) {
      return !1;
    }
  }
};
export {
  t as helper
};
//# sourceMappingURL=helper.es.js.map
